import "core-js/modules/es.array.reduce";
import _defineProperty from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/defineProperty";
// @todo: invent better name
export function createObject(props, value) {
  return props.reduce(function (acc, prop) {
    acc[prop] = value;
    return acc;
  }, {});
}
export function rem(pixelValue) {
  if (pixelValue === 0) return 0;
  return "".concat(pixelValue / 16, "rem");
}
export function responsive(media, statements) {
  return statements.map(function (statement, mediaIndex) {
    if (mediaIndex === 0) return statement;
    var mediaKey = "@media(min-width:".concat(media[mediaIndex - 1], "px)");
    return _defineProperty({}, mediaKey, statement);
  });
}
export function getResponsiveProp(val) {
  var defaultVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (val === undefined) return defaultVal;
  return Array.isArray(val) ? val : [val];
}
export function getResponsiveSpace(theme, props) {
  var spaceIndexes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (!Array.isArray(spaceIndexes)) {
    throw new Error('the property must be array of numbers');
  }

  if (spaceIndexes.length === 0) {
    return null;
  }

  return responsive(theme.sanity.media, spaceIndexes.map(function (spaceIndex) {
    return createObject(props, rem(theme.sanity.space[spaceIndex]));
  }));
}